import { io } from "socket.io-client";

const URL_BASE = process.env.ROOT_SOCKET.toString();

export default class {
    socket;
	status = false;

	conectar(tipo) {
    	this.socket = io(URL_BASE);
    	this.socket.on("connect", () => {
    		this.socket.emit("conectar", tipo);
    	});
	}

	isOnline() {
    	this.socket.on("isOnline", (online) => {
    		this.status = online;
    	},
		 );
	}

	realizarChamado(chamado) {
    	 this.socket.emit("realizarChamado", chamado);
	}
	chamar(chamados) {
    	this.socket.on("chamar", (chamado) => {
    		const index = Array.from(chamados).findIndex(c => c.idExameAgendado == chamado.idExameAgendado);
    		if (index == -1) {
    			const audio = new Audio("../../../static/salamisound-8633049-bell-chime-antique-door.mp3");
    			audio.play();
    			chamados.push(chamado);
    			if (chamados.length == 5) {
    				chamados.splice(0, 1);
    			}
    		}
    	});
	}
	handleError() {
    	this.socket.on("connect_error", (err) => {
    		console.log(err);
    		this.status = false;
    	});
	}
	desconectar(tipo) {
    	this.socket.emit("desconectar", tipo);
    	this.socket = undefined;
		this.status = false;
	}
}



// WEBPACK FOOTER //
// ./src/service/SocketService.js